// Config condivisa modulo Contratti (micro-fase 2)
export const CATEGORIA_DEFAULT_TIPO = {
  assistenza: "Contratto di Assistenza Prepagato",
  flat: "Contratto di Assistenza Flat",
  manutenzione: "Contratto di Manutenzione",
  amministratore_sistema: "Contratto Amministratore di Sistema",
  noleggio_costo_copia: "Costo copia",
};

const TUTTI_TIPI = [
  "Contratto di Assistenza Prepagato",
  "Contratto di Assistenza Flat",
  "Contratto di Manutenzione",
  "Contratto Amministratore di Sistema",
  "Noleggio e Costo Copia",
  "Noleggio",
  "Costo copia",
  "Locazione operativa",
];

export const TIPI_PER_CATEGORIA = {
  assistenza: ["Contratto di Assistenza Prepagato"],
  flat: ["Contratto di Assistenza Flat"],
  manutenzione: ["Contratto di Manutenzione"],
  amministratore_sistema: ["Contratto Amministratore di Sistema"],
  noleggio_costo_copia: ["Costo copia", "Locazione operativa"],
  "": TUTTI_TIPI,
};

export const MODELLI_PER_MARCA = {
  Ricoh: ["MP C3004", "MP C3003"],
  Toshiba: ["e-STUDIO 2500AC", "e-STUDIO 3515AC"],
};

export const PERIODICITA = [
  { v: "mensile", l: "Mensile" }, { v: "bimestrale", l: "Bimestrale" }, { v: "trimestrale", l: "Trimestrale" },
  { v: "semestrale", l: "Semestrale" }, { v: "annuale", l: "Annuale" }, { v: "unica", l: "Unica" },
];

// FLAT: solo Mensile o A progetto (le altre periodicità non si usano per i FLAT)
export const PERIODICITA_FLAT = [
  { v: "mensile", l: "Mensile" }, { v: "a_progetto", l: "A progetto" },
];

// Campi specifici per categoria. scope: "root" (campo diretto del contratto) o "dettagli" (default).
export const CAMPI_SPECIFICI = {
  assistenza: {
    titolo: "Monte ore prepagato",
    fields: [
      { key: "ore_acquistate", label: "Ore acquistate / monte ore", type: "number", scope: "root" },
      { key: "prezzo_unitario_ora", label: "Tariffa oraria teorica (€/ora)", type: "number", scope: "root" },
      { key: "soglia_avviso_ore", label: "Soglia avviso ore residue", type: "number" },
      { key: "scadenza_monte_ore", label: "Scadenza monte ore", type: "date" },
      { key: "note_condizioni", label: "Note condizioni di utilizzo", type: "textarea", full: true },
    ],
  },
  flat: {
    titolo: "Condizioni FLAT",
    fields: [
      { key: "tariffa_listino", label: "Tariffa/listino concordato (€)", type: "number" },
      { key: "monte_ore_massimo", label: "Monte ore massimo", type: "number" },
      { key: "gestione_extra_soglia", label: "Gestione extra soglia", type: "textarea", full: true },
      { key: "data_prossima_verifica", label: "Prossima verifica / rinnovo", type: "date" },
      { key: "note_flat", label: "Note condizioni flat", type: "textarea", full: true },
    ],
  },
  manutenzione: {
    titolo: "Dettagli manutenzione",
    fields: [
      { key: "tipo_manutenzione", label: "Tipo manutenzione", type: "text" },
      { key: "periodicita_manutenzione", label: "Periodicità manutenzione", type: "text" },
      { key: "numero_interventi_inclusi", label: "Interventi inclusi", type: "number" },
      { key: "interventi_eseguiti", label: "Interventi eseguiti", type: "number" },
      { key: "prossima_manutenzione", label: "Prossima manutenzione prevista", type: "date" },
      { key: "ubicazione", label: "Ubicazione", type: "text" },
      { key: "referente_cliente", label: "Referente cliente", type: "text" },
      { key: "importo_contratto", label: "Importo contratto (€)", type: "number" },
      { key: "asset_coperti", label: "Asset/dispositivi coperti", type: "textarea", full: true },
      { key: "note_operative", label: "Note operative manutenzione", type: "textarea", full: true },
    ],
  },
  amministratore_sistema: {
    titolo: "Incarico ADS / GDPR",
    fields: [
      { key: "data_nomina", label: "Data nomina", type: "date" },
      { key: "data_inizio_incarico", label: "Inizio incarico", type: "date" },
      { key: "data_fine_incarico", label: "Fine incarico", type: "date" },
      { key: "referente_privacy", label: "Referente privacy / DPO", type: "text" },
      { key: "titolare_cliente", label: "Titolare / ente cliente", type: "text" },
      { key: "numero_utenti_sistemi", label: "Numero utenti/sistemi amministrati", type: "number" },
      { key: "periodicita_verifiche", label: "Periodicità verifiche", type: "text" },
      { key: "ultima_verifica", label: "Ultima verifica", type: "date" },
      { key: "prossima_verifica", label: "Prossima verifica", type: "date" },
      { key: "allegato_nomina", label: "Presenza allegato nomina", type: "switch" },
      { key: "sistemi_inclusi", label: "Sistemi inclusi nell'incarico", type: "textarea", full: true },
      { key: "note_gdpr", label: "Note GDPR / privacy", type: "textarea", full: true },
    ],
  },
  noleggio_costo_copia: {
    titolo: "Fotocopiatrice / costo copia",
    fields: [
      { key: "marca_fotocopiatrice", label: "Marca fotocopiatrice", type: "select", options: [{ v: "Ricoh", l: "Ricoh" }, { v: "Toshiba", l: "Toshiba" }] },
      { key: "modello_fotocopiatrice", label: "Modello fotocopiatrice", type: "select_modello" },
      { key: "matricola", label: "Matricola / seriale", type: "text" },
      { key: "ubicazione", label: "Ubicazione", type: "text" },
      { key: "canone_noleggio", label: "Canone noleggio (€)", type: "number" },
      { key: "costo_copia_bn", label: "Costo copia B/N (€)", type: "number" },
      { key: "costo_copia_colore", label: "Costo copia colore (€)", type: "number" },
      { key: "copie_incluse_bn", label: "Copie incluse B/N", type: "number" },
      { key: "copie_incluse_colore", label: "Copie incluse colore", type: "number" },
      { key: "periodicita_lettura", label: "Periodicità lettura contatori e relativa fattura", type: "select", default: "Trimestrale", options: [{ v: "Trimestrale", l: "Trimestrale" }, { v: "Mensile", l: "Mensile" }] },
      { key: "note_macchina", label: "Note macchina / contratto", type: "textarea", full: true },
    ],
  },
};
